import { createSlice } from "@reduxjs/toolkit";
import { GetCategories } from "services/dropdown/dropdown.service";
import { toast } from 'react-toastify';

export const categorySlice = createSlice({
  name: "categories",
  initialState: {
    categoryList: [],
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetCategories.pending, () => {
      // toast.success('Promise Pending 🤯');
    });

    builder.addCase(GetCategories.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');
      state.categoryList = action.payload
    });

    builder.addCase(GetCategories.rejected, () => {
      toast.dismiss();
      toast.error('Promise rejected 😣')

    });
  },
});

export default categorySlice.reducer;
